
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cost-of-living",
      function () {
        return require("private-next-pages/cost-of-living.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cost-of-living"])
      });
    }
  